import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { User, Phone, MessageSquare } from "lucide-react";
import api from "../../lib/api";
import { EmployerTabs } from "../../components/employer/EmployerTabs";
import { LockedFeature } from "../../components/employer/LockedFeature";

export default function EmployerApplications() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/employer/applications").then(({ data }) => setData(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const canView = data?.can_view;
  const apps = data?.applications || [];
  const fmt = (d) => (d ? new Date(d).toLocaleDateString(i18n.language) : "");

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-heading text-3xl font-bold text-stone-text mb-6">{t("employer.applications.title")}</h1>
      <EmployerTabs />

      {loading ? (
        <div className="py-12 text-center text-stone-muted">{t("jobs.loading")}</div>
      ) : !canView ? (
        <LockedFeature description={t("employer.locked.applications")} />
      ) : apps.length === 0 ? (
        <div className="py-12 text-center text-stone-muted" data-testid="eapps-empty">{t("employer.applications.empty")}</div>
      ) : (
        <div className="space-y-3" data-testid="eapps-list">
          {apps.map((a) => (
            <div key={a.id} className="bg-white rounded-2xl border border-stone-border shadow-sm p-4" data-testid="eapp-item">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-brand-soft flex items-center justify-center"><User className="w-5 h-5 text-brand" /></div>
                  <div>
                    <h3 className="font-heading font-semibold text-stone-text">{a.candidate_name}</h3>
                    <p className="text-sm text-stone-sub">{a.job?.title}</p>
                  </div>
                </div>
                <span className="text-xs text-stone-muted">{t("employer.applications.appliedOn")} {fmt(a.created_at)}</span>
              </div>
              <div className="flex flex-wrap gap-4 mt-3 text-sm text-stone-sub">
                {a.candidate_phone && <span className="flex items-center gap-1"><Phone className="w-4 h-4 text-brand" /> {a.candidate_phone}</span>}
                {a.message && <span className="flex items-center gap-1"><MessageSquare className="w-4 h-4 text-brand" /> {a.message}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
